/* eslint-disable import/no-anonymous-default-export */
export default {
  articles: {
    list: [],
    current: null,
  },
};
